import { render } from "./Customer1.vue?vue&type=template&id=00c101f1"
import script from "./Customer1.vue?vue&type=script&lang=js"
export * from "./Customer1.vue?vue&type=script&lang=js"

import "./Customer1.vue?vue&type=style&index=0&id=00c101f1&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__